import { useEffect } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import TagManager from 'react-gtm-module';
import useAuth, { useValidateBillingProfileExistence, useValidateSubscriptionState } from './hooks/useAuth';
import RequireAuth from './components/RequireAuth';
import RequireFrame from './components/RequireFrame';
import PersistLogin from './components/PersistLogin';
import Register from './components/Register';
import Login from './components/Login';
import FrameBuilder from './components/FrameBuilder';
import Layout from './components/Layout';
import Invite from './components/Invite';
import Impact from './components/Impact';
import Missing from './components/Missing';
import ForgotPassword from './components/ForgotPassword';
import ResetPassword from './components/ResetPassword';
import Invitations from './page/Invitations';
import URLCrawler from './components/URLCrawler';
import Speakers from './components/Speakers';
import Account from './page/Account';
import Groups from './page/Groups';
import Inactive from './page/Inactive';
import Subscribe from './page/Subscribe';
import RequireSubscription from './components/RequireSubscription';
import SubscribeSuccess from './page/SubscribeSuccess';
import BillingPortal from './page/BillingPortal';

function App() {
  const { auth } = useAuth();
  const isValidSubscriptionState = useValidateSubscriptionState();
  const isBillingProfileExits = useValidateBillingProfileExistence();
  const isAuthenticated = auth?.account;

  useEffect(() => {
    TagManager.initialize({ gtmId: 'GTM-PTJCPWCP' });
  }, []);

  useEffect(() => {
    if (auth?.account) {
      TagManager.dataLayer({
        dataLayer: {
          event: 'userLoggedIn',
          accountId: auth.account.Id,
          accountAdminLevel: auth.account.Role === 'SUPER_ADMIN' ? 'Super Admin' : 'Group Admin',
          accountEmail: auth.account.EmailAddress,
          accountName: auth.account.FirstName + ' ' + auth.account.LastName
        },
      });
    }
  }, [auth.account]);

  return (
    <Routes>
      <Route element={<PersistLogin />}>
        <Route path="/" element={<Layout />}>
          {/* public routes */}
          <Route path="login" element={isAuthenticated ? <Navigate to="/" /> : <Login />} />
          <Route path="register" element={isAuthenticated ? <Navigate to="/" /> : <Register />} />
          <Route path="forgot-password" element={isAuthenticated ? <Navigate to="/" /> : <ForgotPassword />} />
          <Route path="reset-password" element={isAuthenticated ? <Navigate to="/" /> : <ResetPassword />} />

          {/* we want to protect these routes */}
          <Route element={<RequireAuth />}>
            <Route path="inactive" element={isValidSubscriptionState ? <Navigate to="/" /> : <Inactive />} />
            <Route path="subscribe" element={isBillingProfileExits ? <Navigate to="/" /> : <Subscribe />} />
            <Route path="subscribe-success" element={<SubscribeSuccess />} />
            <Route element={<RequireSubscription />}>
              <Route path="account" element={<Account />} />
              <Route path="billing-portal" element={<BillingPortal />} />
              <Route path="/" element={<Groups />} />
              <Route path="/group/:groupId/frame" element={<FrameBuilder />} />
              <Route path="groups" element={<Groups />} />
              <Route path="crawl" element={<URLCrawler />} />
            </Route>
          </Route>
          <Route element={<RequireAuth />}>
            <Route element={<RequireSubscription />}>
              <Route element={<RequireFrame />}>
                <Route path="/group/:groupId/invite" element={<Invite />} />
                <Route path="/group/:groupId/speakers" element={<Speakers />} />
                <Route path="/group/:groupId/impact" element={<Impact />} />
                <Route path="/group/:groupId/invitations" element={<Invitations />} />
              </Route>
            </Route>
          </Route>
        </Route>
        {/* catch all */}
        <Route path="*" element={<Missing />} />
      </Route>
    </Routes>
  );
}

export default App;